// source: pbtypes/gen/surface_scan/surface_scan_flight_analytics.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.surface_scan.SurfaceScanFlightAnalytics', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.surface_scan.SurfaceScanFlightAnalytics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.surface_scan.SurfaceScanFlightAnalytics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.surface_scan.SurfaceScanFlightAnalytics.displayName = 'proto.surface_scan.SurfaceScanFlightAnalytics';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.surface_scan.SurfaceScanFlightAnalytics.prototype.toObject = function(opt_includeInstance) {
  return proto.surface_scan.SurfaceScanFlightAnalytics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.surface_scan.SurfaceScanFlightAnalytics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.surface_scan.SurfaceScanFlightAnalytics.toObject = function(includeInstance, msg) {
  var f, obj = {
flightId: jspb.Message.getFieldWithDefault(msg, 1, ""),
vehicleId: jspb.Message.getFieldWithDefault(msg, 2, ""),
vehicleModel: jspb.Message.getFieldWithDefault(msg, 3, ""),
vehicleName: jspb.Message.getFieldWithDefault(msg, 4, ""),
imageCount: jspb.Message.getFieldWithDefault(msg, 5, 0),
takeoffUclock: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.surface_scan.SurfaceScanFlightAnalytics}
 */
proto.surface_scan.SurfaceScanFlightAnalytics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.surface_scan.SurfaceScanFlightAnalytics;
  return proto.surface_scan.SurfaceScanFlightAnalytics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.surface_scan.SurfaceScanFlightAnalytics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.surface_scan.SurfaceScanFlightAnalytics}
 */
proto.surface_scan.SurfaceScanFlightAnalytics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setFlightId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setVehicleId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setVehicleModel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setVehicleName(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setImageCount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setTakeoffUclock(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.surface_scan.SurfaceScanFlightAnalytics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.surface_scan.SurfaceScanFlightAnalytics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.surface_scan.SurfaceScanFlightAnalytics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.surface_scan.SurfaceScanFlightAnalytics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFlightId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVehicleId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVehicleModel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVehicleName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getImageCount();
  if (f !== 0) {
    writer.writeSint32(
      5,
      f
    );
  }
  f = message.getTakeoffUclock();
  if (f !== 0) {
    writer.writeSint64(
      6,
      f
    );
  }
};


/**
 * optional string flight_id = 1;
 * @return {string}
 */
proto.surface_scan.SurfaceScanFlightAnalytics.prototype.getFlightId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.surface_scan.SurfaceScanFlightAnalytics} returns this
 */
proto.surface_scan.SurfaceScanFlightAnalytics.prototype.setFlightId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string vehicle_id = 2;
 * @return {string}
 */
proto.surface_scan.SurfaceScanFlightAnalytics.prototype.getVehicleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.surface_scan.SurfaceScanFlightAnalytics} returns this
 */
proto.surface_scan.SurfaceScanFlightAnalytics.prototype.setVehicleId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string vehicle_model = 3;
 * @return {string}
 */
proto.surface_scan.SurfaceScanFlightAnalytics.prototype.getVehicleModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.surface_scan.SurfaceScanFlightAnalytics} returns this
 */
proto.surface_scan.SurfaceScanFlightAnalytics.prototype.setVehicleModel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string vehicle_name = 4;
 * @return {string}
 */
proto.surface_scan.SurfaceScanFlightAnalytics.prototype.getVehicleName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.surface_scan.SurfaceScanFlightAnalytics} returns this
 */
proto.surface_scan.SurfaceScanFlightAnalytics.prototype.setVehicleName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional sint32 image_count = 5;
 * @return {number}
 */
proto.surface_scan.SurfaceScanFlightAnalytics.prototype.getImageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.surface_scan.SurfaceScanFlightAnalytics} returns this
 */
proto.surface_scan.SurfaceScanFlightAnalytics.prototype.setImageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional sint64 takeoff_uclock = 6;
 * @return {number}
 */
proto.surface_scan.SurfaceScanFlightAnalytics.prototype.getTakeoffUclock = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.surface_scan.SurfaceScanFlightAnalytics} returns this
 */
proto.surface_scan.SurfaceScanFlightAnalytics.prototype.setTakeoffUclock = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


goog.object.extend(exports, proto.surface_scan);
